import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import scripts from './modules/scripts';
import static_assets from './modules/static_assets';
import docs from './modules/docs';
import player_settings from './modules/player_settings';
import assetdb from './modules/assetdb';

Vue.use(Vuex);

export function mapStates (namespace, states) {
  const mappedStates = mapState(namespace, states);
  const res = {};
  for (const key in states) {
    const value = states[key];
    res[key] = {
      set (update) {
        this.$store.commit(namespace + '/' + value, update);
      },
      get () {
        return mappedStates[key].call(this);
      }
    };
  }
  return res;
}

export default new Vuex.Store({
  state: {
    error: null
  },
  mutations: {
    setError (state, error) {
      state.error = error;
    }
  },
  modules: { scripts, static_assets, docs, player_settings, assetdb },
  strict: false
});
